<template>
  <div class="mainContent">
    <div class="moduleMain cityChoose">
      <div class="cityLogo">
        <div class="logo1">
          <img
            src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/generalSetting/16274407759908.png"
            alt=""
          />
        </div>
        <div class="logo2">
          <img
            src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/tkwx/16280426788666810263841.png"
            class="mb20"
            alt=""
          />
          <img
            src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/generalSetting/16274408477625.png"
            alt=""
          />
        </div>
      </div>
      <div>
        <el-popover
          placement="bottom"
          width="400"
          trigger="hover"
          v-for="item in regionList"
          :key="item.id"
          :value="item.cityPopover == 0 ? false : true"
        >
          <span
            slot="reference"
            style="
              margin-right: 35px;
              display: inline-block;
              margin-bottom: 15px;
              font-size: 16px;
            "
          >
            {{ item.name }}</span
          >
          <p v-for="item2 in item.childrenList" :key="item2.id" class="city-single">
            <span @click="cityChoose(item2.name)">{{ item2.name }}</span>
          </p>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "city-template",
  data() {
    return {
      regionList: [],
    };
  },
  methods: {
    cityList() {
      var instance = axios.create({
        baseURL: process.env.BASE_URL,
        timeout: 10000 * 60,
      });
      instance.defaults.headers.get["Content-Type"] =
        "application/x-www-form-urlencoded;charset=utf-8";
      instance
        .get("/dictionary/getDictionaryListNoAgent", { params: { parentId: "2" } })
        .then((res) => {
          this.regionList = res.data.data;
        });
    },
  },
  mounted() {
    this.cityList();
  },
};
</script>

<style scoped>
.mainContent {
  /* width: 1200px; */
  font-size: 16px;
  width: 80%;
  min-width: 900px;
  margin: 0 auto;
}

.mainContent img {
  max-width: 860px;
}
.moduleMain {
  margin-top: 40px;
  width: 1200px;
  margin: 0 auto;
}
.city-single {
  display: inline-block;
}
.city-single span {
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 15px;
  cursor: pointer;
}
.city-single span:hover {
  color: #266ef6;
}
/*城市样式*/
.cityChoose {
  display: flex;
  background: #fff;
  margin: 20px 0 40px;
  padding: 20px 40px;
  align-items: center;
}
.cityLogo {
  display: flex;
  margin-right: 115px;
}
.cityLogo .logo1 img {
  margin-right: 20px;
  width: 40px;
  height: 40px;
}
.cityLogo .logo2 img {
  width: 95px;
  height: 25px;
}
.mb20 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/cityTemplate.vue